import { mapState, mapGetters } from 'vuex'
import { Button, Popup, Cell, CellGroup, Field, picker, Tag, Collapse, CollapseItem, ActionSheet, Checkbox } from 'vant'
import { formatDate } from 'Utils/dateUtil'
import { getName } from 'Utils/publicFun'
import { queryVipParameter } from '@/business/utils/publicApi'
import hotelMixin from '../htQuery/hotelMixin'

export default {
  name: 'HtOrder',
  mixins: [hotelMixin],
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Tag.name]: Tag,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [ActionSheet.name]: ActionSheet,
    [Checkbox.name]: Checkbox,
    [picker.name]: picker,
    empList: () => import('Components/ldEmpList/index.vue'),
    travelInfo: () => import('Components/travelInfo'),
    ldTabbar: () => import('Components/ldTabbar/ldTabbar'),
    ldButton: () => import('Common/ldButton'),
    HtContactTime: () => import('Views/Ht/htQuery/htContactTime/index.vue'),
    HtCreditCard: () => import('Views/Ht/htQuery/htCreditCard/index.vue'),
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldEditLinker: () => import('Components/ldEditLinker')
  },
  data() {
    return {
      max:'',
      min:'',
      maxweek:'',
      minweek:'',
      down: { use: false },
      isContact: false,
      isContactTime: false,
      isCreditCard: false,
      activeName: [],
      priceList: [],
      roomItems: [],
      latestArrivalTime_: '',
      creditCard_: {},
      linker: {},
      travelInfo: {},
      showPicker: false,
      shouRzrsm: false,
      columns: [
        {
          text: '身份证',
          value: 1
        },
        {
          text: '护照',
          value: 2
        },
        {
          text: '军人证',
          value: 3
        },
        {
          text: '其他',
          value: 4
        }
      ],
      pickerData: {},
      isReadCancelRuleChecked: false,
    }
  },
  computed: {
    ...mapState({
      /**
       * 酒店详情数据模型
       */
      data_: (state) => state.ht.orderDetails,
      model: state => state.ht.htSearchInfo,
      interfacePlat: state => state.ht.interfacePlat,
      /**
       * 出行人集合
       */
      travelerList: (state) => state.ht.travelerList,
      userInfo: (state) => state.app.userInfo,
      /**
       * 页面差旅标准对象
       */
      pageCtrl: state => state.ht.pageCtrl
    }),
    ...mapGetters({
      sysType:'sysType'
    })
  },

  update(){

  },
  created () {

    if(this.$route.query.i==1){
      this.max = formatDate(this.model.checkInDate).monDay
      this.maxweek = formatDate(this.model.checkInDate).week
      this.min = formatDate(this.model.checkOutDate).monDay
      this.minweek = formatDate(this.model.checkOutDate).week
    }else{
      this.max = formatDate(this.model.checkInDate).monDay2
      this.maxweek = formatDate(this.model.checkInDate).week
      this.min = formatDate(this.model.checkOutDate).monDay2
      this.minweek = formatDate(this.model.checkOutDate).week
    }
    console.log('this',this)

  },
  mounted() {
    this.init()
  },
  methods: {
    async init () {
      // 如果到订单填写没选出行人，则是默认出行人是自己
      if (!this.travelerList.length) {
        this.userInfo.empInfo.checked = true
        this.userInfo.empInfo.clkFlag = 2
        this.travelerList.push(this.userInfo.empInfo)
        this.$store.commit('ht/travelerList', this.travelerList)
      }

      /**
       * 匹配联系人信息
       */
      this.linker = {
        linkMan: this.userInfo.empInfo.empName,
        linkTel: this.userInfo.empInfo.phoneNumber,
        linkEmail: this.userInfo.empInfo.email
      }

      /**
       * 初始化
       */
      this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, {
        _linkman: this.userInfo.empInfo.empName,
        _linkMobile: this.userInfo.empInfo.phoneNumber,
        _linkEmail: this.userInfo.empInfo.email,
        _latestArrivalTime: '17:00'
      }))


      /**
       * 获取出行人，确定房间数，初始化数组
       * 每个房间首先分配一人，不超过5间房，多余的从第一间房往下分配，每间房不得大于2人
       * 先根据当前首次选择的人数可上限匹配几间房
       *
       * 2021年8月21日17:30:32
       *  生成房间根据 是否拼房 是：默认两人一间，否：一人一间
       *
       * 2021年8月26日10:21:25
       *  如果没有是否拼房的展示，还是按原来的逻辑分配芳姐
       */
      setTimeout(() => {
        if (this.pageCtrl.isShowPf) {
          this.structureRoom(this.model.sfpf ? Math.ceil(this.travelerList.length / 2) : this.travelerList.length)
        } else {
          this.structureRoom(this.travelerList.length < 5 ? this.travelerList.length : 5)
        }

        /**
       * 按单/间夜匹配服务费
       */
        this.matchQuery()

      }, 1000)

      /**
       * 如果走出差申请单模式 回显出差申请单信息
       */
      if (this.model._ccsqPattern.checked) {
        setTimeout(() => {
          this.$refs._travelInfo.getInfo(this.model._ccsqPattern.obj)
        }, 1000)
      }
      if (this.data_._violation) this.data_._violation.violateItem = this.data_._violation.violateitem
      setTimeout(() => {
        if (this.model.tripType == 1 && this.data_._violation){
          this.$refs._travelInfo.getInfo(this.data_._violation)
        }
      }, 1000)

      /**
       * 获取是否默认勾选阅读取消规则的参数
       */
      let data = await queryVipParameter('1517')
      if (data.value1 == 1) this.isReadCancelRuleChecked = true
    },
    empCallBack() {
      this.structureRoom(this.travelerList.length > this.roomItems.length * 2 ? (Math.ceil(this.travelerList.length / 2)) : this.roomItems.length)
    },
    /**
     * 提交订单
     */
    onSubmit() {
      /**
       * 因公 model.tripType == 1
       * 差旅信息验证
       */
      if (this.model.tripType == 1) {
        let bl = this.$refs._travelInfo.result()
        if (!bl) {
          return false
        }
      }

      /**
       * 到店付 && 需担保
       * 需要完善信用卡信息再下订
       */
      if (this.data_._ratePlans.payment == '1' && this.data_._guarantee.isVouch == '1') return this.isCreditCard = true

      /**
       * 是否勾选了阅读取消规则
       */
      if (!this.isReadCancelRuleChecked) {
        this.$toast('请先阅读取消规则并勾选')
        return
      }

      /**
       * 下单
       */
      this.book()

    },
    /**
     * 调整房间数
     */
    onChangeRoomNum(value) {
      this.model._roomNum = value
      let currentNum = this.roomItems.length

      if (value > currentNum) {
        for (let i = 0; i < value - currentNum; i++) {
          this.roomItems.push( [{empName: ''}] )
        }
      } else {
        this.roomItems.splice(value, currentNum - value)
      }
      this.matchQuery()
    },
    structureRoom(rooms) {
      console.log(rooms)
      this.roomItems = []
      this.travelerList.forEach((element, index) => {
        if (this.roomItems.length < rooms) {
          this.roomItems[index] = []
          this.roomItems[index].push(element)
          this.roomItems[index][0]['empName'] = getName(element)
        } else {
          if (index - rooms < this.roomItems.length) {
            this.roomItems[index - rooms].push(element)
            this.roomItems[index - rooms][1]['empName'] = getName(element)
          }
        }
      })
      console.log(this.roomItems,'已经添加的人的数据')
      this.model._roomNum = this.roomItems.length

      this.structureDetailed()

      if (this.pageCtrl.isStart) {
        this.getTravelPolicy(this.roomItems)
      }
    },
    getServiceFee() {
      this.$api['htQuery/pricePlanOne']({
        hotelId: this.data_.jdid, // 平台酒店id，列表查询返回的酒店ID
        interfacePlatEnum: this.data_._ratePlans && this.data_._ratePlans.fyid, // 接口供应商标识，列表查询返回的接口供应商标识
        checkInDate: this.model._checkInDate.date, // 入住日期：yyyy-mm-dd
        checkOutDate: this.model._checkOutDate.date, // 离店日期：yyyy-mm-dd
        roomId: this.data_._ratePlans.roomId, // 平台房型编号，传入时表示指定房型查询
        ratePlanId: this.data_._ratePlans.ratePlanId, // 价格计划id,重选日期的时候使用
        singaZhid: this.interfacePlat.singaZhid,
        searchPlatZhid: this.interfacePlat.platZhid,
        tripType: this.model.tripType // 出差类型 1:因公 2因私，默认1
      }).then(res => {
        this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, {
          _totalFwf: res.data.totalFwf || 0
        }))
      }).catch(() => {})
    },
    matchQuery() {
      let fwfMatchList_ = []
      this.data_._ratePlans.nightlyRates && this.data_._ratePlans.nightlyRates.forEach(element => {
        fwfMatchList_.push({
          date: element.date,
          salePrice: element.salePrice
        })
      })
      this.$api['htQuery/matchQuery']({
        'corpId': '', // 企业ID，OBT无需传入。OSS后台查询时如果选择了企业，需传入。集中采购页面从需从订单上获取传入
        'roomCount': this.model._roomNum, // 房间数
        'cplx': '10903', // 产品类型编号，对应产品枚举编号，10903：国内酒店，10910：国际酒店
        'jgly': this.data_._ratePlans.bussType == '1' ? '2' : (this.data_._ratePlans.bussType == '2' ? '3' : '1'), // 价格来源， 1：平台，2：代理自签 ，3：企业自签 ,
        'type': this.model.tripType, // 因公因私，1：公 0：私 ,
        'fwfMatchList': fwfMatchList_
      }).then(res => {
        this.$store.commit('ht/orderDetails', Object.assign(this.data_, {
          _matchQueryData: res.data
        }))
        /**
         * payment: 1 到店付订单 判断是否需要担保
         */
        if (this.data_._ratePlans.payment == '1') {
          if (this.model.checkInDate > formatDate(new Date()).date) {
            this.latestArrivalTime_ = '18:00'
          }
          if (this.model.checkInDate == formatDate(new Date()).date) {
            var h = formatDate(new Date()).hm
            if (h > '00:00' && h < '06:00') {
              this.latestArrivalTime_ = '06:00'
            } else if (h > '06:00' && h < '18:00') {
              this.latestArrivalTime_ = '18:00'
            } else if (h > '18:00' && h < '23:59') {
              this.latestArrivalTime_ = '23:30'
            }
          }
          this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, {
            _latestArrivalTime: this.latestArrivalTime_
          }))
          this.guarantee()
        } else {
          this.structureDetailed()
        }
      }).catch(() => {})
    },
    /**
     * 最晚到店时间回调
     */
    listenChildContactTime(data) {
      this.isContactTime = false
      this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, {
        _latestArrivalTime: data.value
      }))
      /**
       * 请求酒店下单担保接口 payment: 1 到店付需要
       */
      this.data_._ratePlans.payment == '1' && this.guarantee()
    },
    /**
     * 信用卡担保回调
     */
    listenChildCreditCard(data) {
      this.isCreditCard = false
      this.creditCard_ = data
      /**
       * 下单
       */
      this.book()
    },
    /**
     * 请求酒店下单担保接口 payment: 1 到店付需要
     * 判断是否需要担保
     */
    guarantee() {
      this.$api['htQuery/guarantee']({
        'singaZhid': this.interfacePlat.singaZhid,
        'platZhid': this.interfacePlat.platZhid,
        'hotelId': this.data_.jdid, // 酒店id
        'interfacePlatEnum': this.data_._ratePlans && this.data_._ratePlans.fyid, // 接口供应商标识
        'roomId': this.data_._ratePlans.roomId, // 房型编码，本地房型
        'ratePlanId': this.data_._ratePlans.ratePlanId, // 价格计划id
        'checkInDate': this.model.checkInDate, // 入住日期：yyyy-mm-dd
        'checkOutDate': this.model.checkOutDate, // 离店日期：yyyy-mm-dd
        'latestArrivalTime': this.data_._latestArrivalTime, // 最晚到店时间 HH:mm
        'numberOfRooms': this.roomItems.length // 房间数量
      }).then(res => {
        this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, {
          _guarantee: res.data
        }))
        /**
         * 构建明细面板
         */
        this.structureDetailed()
      }).catch(() => {})
    },
    structureDetailed() {
      /**
       * 初始化 this.priceList
       */
      this.priceList = []

      /**
       * 到店付 && 需要担保的 需要在明细面板中展示[在线担保金额]
       */
      if (this.data_._ratePlans && this.data_._ratePlans.payment == '1' && this.data_._guarantee && this.data_._guarantee.isVouch == '1') {
        this.priceList.push({
          name: '在线担保',
          price: this.data_._guarantee.amount,
          amount: this.roomItems.length,
          unit: '间'
        })
      }

      /**
       * priceAfterTax 供应商税后价格（成本价）没值
       * data_._matchQueryData.chargeType 空 || 1: 按间夜 2：按单
       */
      if (this.data_._matchQueryData && this.data_._matchQueryData.chargeType == '2' || this.data_._matchQueryData && !this.data_._matchQueryData.chargeType) {
        this.data_._ratePlans.nightlyRates.forEach(element => {
          this.priceList.push({
            name: element.date,
            price: element.salePrice,
            amount: this.roomItems.length,
            unit: '间'
          })
        })
      }

      if (this.data_._matchQueryData && this.data_._matchQueryData.chargeType == '1') {
        this.data_._matchQueryData.mxBeanList.forEach(element => {
          this.priceList.push({
            name: element.date,
            price: element.salePrice,
            amount: this.roomItems.length,
            unit: '间'
          })
        })
      }

      this.priceList.push({
        name: '服务费',
        price: this.data_._matchQueryData && this.data_._matchQueryData.fwfSum || 0,
        amount: this.data_._matchQueryData && this.data_._matchQueryData.chargeType == '1' ? this.roomItems.length : '',
        unit: this.data_._matchQueryData && this.data_._matchQueryData.chargeType == '1' ? '间' : ''
      })
    },
    roomChecked (outerIndex, index, type) {
      if (this.roomItems[outerIndex].list[index] && type) {
        this.roomItems[outerIndex].list[index].checked = true
        this.roomItems[outerIndex].index += 1
      }
      if (!type) {
        this.roomItems[outerIndex].index -= 1
        this.roomItems[outerIndex].list[this.roomItems[outerIndex].index].checked = false
      }
    },
    async getTravelPolicy (roomItems) {
      this.data_._violation = {
        reasonCode: '',
        reasonDesc: '',
        violateitem: '',
        violateItem: ''
      }
      this.$refs._travelInfo.getInfo(this.data_._violation)

      await this.$store.dispatch('ht/getTravelPolicy', roomItems)

      /**
       * 判断当前的酒店价格计划是否违背现差旅标准
       */
      if (this.iswb(this.data_._ratePlans)) {
        this.data_._violation = {
          reasonCode: this.data_._reason && this.data_._reason.reasonCode || '',
          reasonDesc: this.data_._reason && this.data_._reason.reasonDesc || '',
          violateitem: '本次预订差旅标准，平均间夜不得高于' + this.model._policy.clzcJe + '元/夜',
          violateItem: '本次预订差旅标准，平均间夜不得高于' + this.model._policy.clzcJe + '元/夜',
        }
        this.$refs._travelInfo.getInfo(this.data_._violation)
      } else {
        console.log('=不违背=')
      }
    },
    book() {
      let orderRooms_ = []
      let msg_ = ''
      this.roomItems.forEach((element, index) => {
        let customers_ = []
        element.forEach((element_, index_) => {
          customers_.push({
            'clbzj': this.model._policy.clzcJe,
            'email': element_.email,
            'empDeptId': element_.deptId,
            'empId': element_.empId,
            'fsEmpId': '', // 附属员工id 暂不传
            'gender': element_.sex,
            'idCardNo': this.data_._ratePlans.needIdNo == '1' ? element_.idCardNo : '',
            'mobile': '', // 手机 暂不传
            'name': element_.contactsId ? element_.chName : element_.empName,
            'nationality': element_.nationCode,
            'phone': element_.phoneNumber
          })
          if (this.data_._ratePlans.needIdNo == '1' && !element_.idCardNo) {
            msg_ = '房间'+(index+1)+'的第'+(index_+1)+'个入住人的证件号码不能为空'
          }
        })
        orderRooms_.push({
          customers: customers_,
          roomNo: index + 1
        })
      })
      if (msg_) return this.$toast(msg_)
      /**
       * 到店付订单 && 需要担保
       */
      let _creditCard = undefined
      if (this.data_._ratePlans && this.data_._ratePlans.payment == '1' && this.data_._guarantee && this.data_._guarantee.isVouch == '1') {
        _creditCard = {
          'orderId': '', // 订单列表[担保]需要传具体订单id
          'number': this.creditCard_.number || '',
          'cvv': this.creditCard_.cvv || '',
          'expirationYear': this.creditCard_.expirationYear || '',
          'expirationMonth': this.creditCard_.expirationMonth || '',
          'holderName': this.creditCard_.holderName || '',
          'idType': this.creditCard_.idType || '',
          'cardType': this.creditCard_.cardType || '',
          'idNo': this.creditCard_.idNo || '',
          'tel': this.creditCard_.tel || '',
          'dbJe': this.data_._guarantee && this.data_._guarantee.amount || 0
        }
      }
      if (this.model.tripType == 1) {
        let bl = this.$refs._travelInfo.result()
        if (bl === false) {
          return false
        } else {
          this.travelInfo = bl
        }
      }

      /**
			 * 是否可以正常预定下单
			 */
      if (!this.canbook(this.data_._ratePlans)) return this.$toast('您选择的出行人违背差旅标准，不允许预订，请重新选择。')

      /**
			 * 如果违背了，违背原因和违背说明不能为空
			 */
      if (this.iswb(this.data_._ratePlans)) {
        if (!this.travelInfo.reasonCode || !this.travelInfo.reasonDesc) {
          return this.$toast('违背原因不能为空')
        }
      }

      // 判断处理中宏越供应生单
      let interfacePlatEnum = this.data_.facilitator
      console.log('interfacePlatEnum be  : ', interfacePlatEnum)
      if(interfacePlatEnum != '2000059'){
        interfacePlatEnum = this.data_._ratePlans && this.data_._ratePlans.fyid
      }
      console.log('interfacePlatEnum af  : ', interfacePlatEnum)

      this.$api['htQuery/book']({
        'singaZhid': this.interfacePlat.singaZhid,
        'platZhid': this.interfacePlat.platZhid,
        // 'cityId': this.data_.cityId,
        'cityId': this.model.cityId,
        // 'interfacePlatEnum': this.data_._ratePlans && this.data_._ratePlans.fyid,
        'interfacePlatEnum': interfacePlatEnum,
        // 'hotelId': this.data_.jdid,
        'hotelId': this.data_.jdid + '&' + this.data_._ratePlans.ptJdid,
        'roomId': this.data_._ratePlans.roomId,
        'ratePlanId': this.data_._ratePlans.ratePlanId,
        'checkInDate': this.model.checkInDate,
        'checkOutDate': this.model.checkOutDate,
        'payment': this.data_._ratePlans.payment,
        'latestArrivalTime': this.data_._latestArrivalTime,
        'subjectCode': '', // 暂不传
        'ifSameOrder': '', // 暂不传
        'noteToHotel': '', // 暂不传
        'orderRooms': orderRooms_,
        'linkman': this.linker.linkMan,
        'linkMobile': this.linker.linkTel,
        'tripType': this.model.tripType,
        'linkEmail': this.linker.linkEmail,
        'creditCard': _creditCard,
        'sfpf': this.model.sfpf ? 1 : 0,
        'travelInfo': {
          'ccsqdId': this.travelInfo.ccsqdId || '', // 出差申请单id
          'ccsqdNo': this.travelInfo.ccsqdNo || '', // 出差申请单号
          'ccsqdRemark': this.travelInfo.ccsy||this.travelInfo.ccsqdRemark || '', // 出差申请备注
          'corpCode': '', // 企业代码
          'corpId': '', //  企业id
          'corpName': '', // 企业名称
          'costCenterCode': this.travelInfo.costCenterCode || '', // 成本中心代码
          'costCenterId': this.travelInfo.costCenterId || '', // 成本中心id
          'costCenterName': this.travelInfo.costCenterName || '', // 成本中心名称
          'ifSameOrder': '', // 订单是否一致 DY DN
          'projectCode': this.travelInfo.projectCode || '', // 出差项目代码
          'projectId': this.travelInfo.projectId || '', // 出差项目id
          'projectName': this.travelInfo.projectName || '', // 项目名称
          'reasonCode': this.travelInfo.reasonCode || '', // 违背原因代码
          'reasonDesc': this.travelInfo.reasonDesc || '', // 违背原因说明
          'routeId': this.$route.query.routeId || '', // 行程id
          'subjectCode': this.travelInfo.subjectCode, // 科目码
          'tripType': this.model.tripType, // 因公因私,1是因公,2是因私
          'violateitem': this.data_._violation ? (this.data_._violation.reasonCode && '每间房不得高于'+this.model._policy.clzcJe+'元/间夜') : '', // 违背事项说明
          'violateitemCode': this.data_._violation ? (this.data_._violation.reasonCode && '11109') : '' // 违背事项代码
        },
        'orderFrom': this.sysType,
        'protocol': this.data_._ratePlans.protocol
      }).then(res => {

        let cache = res.data || {}
        let orderId = cache.orderId || ''
        let orderNo = cache.orderNo || ''
        let spgzId = cache.spgzId || ''

        // 用户提交订单是否自动送审（1：是；0：否；）
        this.$api['common/queryParameter']({
          'paramNos': '20023'
        }).then(res => {
          let p_20023 = false
          if (res.data && res.data.parameterResponses && res.data.parameterResponses[0] && res.data.parameterResponses[0].value1) {
            p_20023 = res.data.parameterResponses[0].value1 === '1'
          }
          if (p_20023 && spgzId) {

            // 送审
            this.$api['approval/vipBpmSendAppNew']({
              'orderType': '11007',
              'againApp': 1,
              'orderId': orderId,
              'orderNo': orderNo,
              'spgzId': spgzId,
            }).then(res => {
              this.$router.push({path: '/allorder'})

              // // 查询审批中订单
              // this.$api['approval/vipBpmForMyAppNew']({
              //   'approveType': 1,
              //   'count': 50,
              //   'orderNo': orderNo,
              // }).then(res => {
              //   let approvingList = res.data.list[0].vipBpmForMyAppDtoList
              //   for (let approve of approvingList) {
              //     if (approve.orderId === orderId) {
              //       // 审批订单
              //       this.$api['approval/vipBpmReceiveAppResult']({
              //         'appRemark': '',
              //         'completeState': 1,
              //         'completeWay': 2,
              //         'workItemId': approve.workItemId
              //       });
              //       break;
              //     }
              //   }
              //
              //   this.$router.push({path: '/allorder'});
              // });
            })
          } else {
            // 传值 将询价单id与酒店id
            this.$router.push({path: '/ht/htOrderComplete', query: {orderId: orderId}})
          }
        }).catch(() => {
          // 传值 将询价单id与酒店id
          this.$router.push({path: '/ht/htOrderComplete', query: {orderId: orderId}})
        })
      }).catch(() => {})
    },
    showPickerMethod() {
      this.showPicker = true
    },
    onConfirm(value) {
      this.pickerData = {
        _typeName: value.text,
        idType: value.value,
      }
      this.showPicker = false
    },
  },
  watch: {}
}
